const themeOverrides = {
  typography: {
    fontFamily: "Roboto Flex",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    // Font sizes mapped to MUI variants
    fontSize: 16, // base font size (1rem = 16px)
  },
  // Custom font size scale
  customFontSizes: {
    10: "0.625rem", // 10px
    12: "0.75rem", // 12px
    13: "0.8125rem", // 13px
    14: "0.875rem", // 14px
    15: "0.9375rem", // 15px
    16: "1rem", // 16px
    20: "1.25rem", // 20px
    24: "1.5rem", // 24px
    28: "1.75rem", // 28px
    32: "2rem", // 32px
    40: "2.5rem", // 40px
    68: "4.25rem", // 68px
  },
};
export default themeOverrides;
